export default __webpack_public_path__ + "static/media/spa-image-07.21d6da45.jpg";